'use strict';

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _isServer = require('../utils/isServer');

var _isServer2 = _interopRequireDefault(_isServer);

var _transformOpmlResponseData = require('../utils/transformOpmlResponseData');

var _transformOpmlResponseData2 = _interopRequireDefault(_transformOpmlResponseData);

var _OpmlError = require('../errors/OpmlError');

var _tuneInRequest = require('../tuneInRequest');

var _tuneInRequest2 = _interopRequireDefault(_tuneInRequest);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = function subscriptionService(config, apiContext, applyReauth) {
  var proxyEndpoint = '' + config.domains.local;
  var accountsApiEndpoint = config.domains.opml + '/Account.ashx';
  var loopback = '' + config.domains.loopback + proxyEndpoint;

  // Have to check whether we are on the server since loopback
  // won't work on the client.
  var loopbackOrProxyEndpoint = (0, _isServer2.default)() ? loopback : proxyEndpoint;
  var productsEndpoint = loopbackOrProxyEndpoint + '/products';
  var subscriptionEndpoint = loopbackOrProxyEndpoint + '/subscriptions';

  function getDefaultProduct(params) {
    return (0, _tuneInRequest2.default)({
      method: 'get',
      url: productsEndpoint + '/default/',
      disableCamelCase: true,
      noAuthHeader: true,
      params: {
        countryCode: params.countryCode,
        noCache: params.noCache
      }
    }, apiContext);
  }

  function getProductBySku(params) {
    return (0, _tuneInRequest2.default)({
      method: 'get',
      url: productsEndpoint + '/' + params.sku + '/',
      disableCamelCase: true,
      noAuthHeader: true,
      params: {
        countryCode: params.countryCode,
        noCache: params.noCache
      }
    }, apiContext);
  }

  function getProductsBySkus(params) {
    return (0, _tuneInRequest2.default)({
      method: 'get',
      url: productsEndpoint + '/list/?' + params.skus,
      disableCamelCase: true,
      noAuthHeader: true,
      params: {
        countryCode: params.countryCode,
        noCache: params.noCache
      }
    }, apiContext);
  }

  function getSubscription(params) {
    return (0, _tuneInRequest2.default)({
      method: 'get',
      url: subscriptionEndpoint + '/get/',
      params: {
        countryCode: params.countryCode,
        noCache: params.noCache
      }
    }, apiContext);
  }

  function createSubscription(params) {
    return (0, _tuneInRequest2.default)({
      method: 'post',
      url: subscriptionEndpoint + '/create/',
      params: params,
      disableRetry: true
    }, apiContext);
  }

  function renewSubscription(params) {
    return (0, _tuneInRequest2.default)({
      method: 'post',
      url: subscriptionEndpoint + '/renew/',
      params: params,
      disableRetry: true
    }, apiContext);
  }

  function cancelSubscription() {
    return (0, _tuneInRequest2.default)({
      method: 'post',
      url: subscriptionEndpoint + '/cancel/'
    }, apiContext);
  }

  function linkSubscription(params) {
    return (0, _tuneInRequest2.default)({
      method: 'post',
      url: accountsApiEndpoint,
      params: _extends({}, params, {
        c: 'linkSubscription',
        render: 'json'
      }),
      disableRetry: true,
      transformResponse: _transformOpmlResponseData2.default
    }, apiContext).then(_OpmlError.handleOpmlError);
  }

  function getPaymentInformation() {
    return (0, _tuneInRequest2.default)({
      method: 'get',
      url: subscriptionEndpoint + '/payment/',
      disableRetry: true
    }, apiContext);
  }

  function updatePaymentInformation(params) {
    return (0, _tuneInRequest2.default)({
      method: 'put',
      url: subscriptionEndpoint + '/payment/',
      params: params,
      disableRetry: true
    }, apiContext);
  }

  function lookupCoupon(couponCode, status) {
    return (0, _tuneInRequest2.default)({
      method: 'get',
      url: loopbackOrProxyEndpoint + '/coupons/' + couponCode + '/',
      params: {
        status: status
      },
      disableRetry: true,
      // Disabling the camel case transform as it does not transform arrays of strings properly
      // (see note in `src/utils/camelCase.js`). Since we control this particular API and natively
      // use camelcased keys, it's safe to disable this.
      disableCamelCase: true
    }, apiContext);
  }

  // deprecated
  var geminiApiEndpoint = config.domains.subscriptionApi + '/gemini';
  var zuoraSubscriptionEndpoint = geminiApiEndpoint + '/subscriptions';

  // deprecated
  function getZuoraSubscription() {
    return (0, _tuneInRequest2.default)({
      method: 'get',
      url: zuoraSubscriptionEndpoint + '/get/'
    }, apiContext);
  }

  // deprecated
  function cancelZuoraSubscription() {
    return (0, _tuneInRequest2.default)({
      method: 'post',
      url: zuoraSubscriptionEndpoint + '/cancel/'
    }, apiContext);
  }

  // deprecated
  function getSignature(params) {
    return (0, _tuneInRequest2.default)({
      method: 'get',
      url: geminiApiEndpoint + '/hmac/',
      params: params
    }, apiContext);
  }

  return {
    getDefaultProduct: getDefaultProduct,
    getProductBySku: getProductBySku,
    getProductsBySkus: getProductsBySkus,
    lookupCoupon: lookupCoupon,
    getSubscription: applyReauth(getSubscription),
    cancelSubscription: applyReauth(cancelSubscription),
    getPaymentInformation: applyReauth(getPaymentInformation),
    updatePaymentInformation: applyReauth(updatePaymentInformation),
    getSignature: applyReauth(getSignature),
    createSubscription: applyReauth(createSubscription),
    renewSubscription: applyReauth(renewSubscription),
    linkSubscription: applyReauth(linkSubscription),
    getZuoraSubscription: applyReauth(getZuoraSubscription),
    cancelZuoraSubscription: applyReauth(cancelZuoraSubscription)
  };
};
//# sourceMappingURL=subscription.js.map